import axios from 'api';

export const getAnalyticsConfigData = async () => {
  return axios.get(`api/elastic/analytics_config`);
};

export const allFilter = (filterData, signal) => {
  return axios.post(`api/elastic/analytics/`, filterData, {
    signal: signal
  });
};

export const getFilterData = () => axios.get(`/api/elastic/evalution_features/`);

export const getCardDataData = async (data, signal) => {
  return axios.post(`api/elastic/analytics`, data, {
    signal: signal
  });
};

export const addAnalyticsFeedBackData = async (params) => {
  return axios.post(`api/elastic/feedback/`, params);
};
export const getTableData = async (data, signal) => {
  return axios.post(`api/elastic/analytics_view_summary_table`, data, {
    signal: signal
  });
};
export const getChartData = async (data) => {
  return axios.post(`api/elastic/analytics_view_summary_graph`, data);
};

export const getAllUsersData = async () => {
  return axios.get(`api/account/usermanage/?get_all=${true}`);
};
